import { Page } from '@playwright/test';

export interface VisualAssertOptions {
  page?: Page;
  imageBase64?: string;
  prompt: string;
  context?: string | null;
}
